module.exports = __webpack_public_path__ + "images/mobile-app-design-nobg.be39265ec53a3e7c7cb42ce77ace8f82.svg";